module.exports = __webpack_public_path__ + "img/1988_S.505f2626.png";